import { handleActions } from 'redux-actions';
import {
  SECTION_OFFSET_CHANGE,
  SECTION_SET_IN_VIEW,
} from '../actions/types';

const defaultState = {
  intro: {
    navTitle: null,
    navEmphasis: false,
    navLink: null,
    isExternalLink: false,
    wasInView: false,
    offset: 0,
  },
  history: {
    navTitle: 'La nostra storia',
    navEmphasis: false,
    navLink: '#history',
    isExternalLink: false,
    wasInView: false,
    offset: Infinity,
  },
  quote: {
    navTitle: null,
    navEmphasis: false,
    navLink: null,
    isExternalLink: false,
    wasInView: false,
    offset: Infinity,
  },
  map: {
    navTitle: 'Dove siamo',
    navEmphasis: false,
    navLink: '#map',
    isExternalLink: false,
    wasInView: false,
    offset: Infinity,
  },
  'new-products': {
    navTitle: 'Nuovi prodotti',
    navEmphasis: false,
    navLink: '#new-products',
    isExternalLink: false,
    wasInView: false,
    offset: Infinity,
  },
  'all-products': {
    navTitle: 'Catalogo',
    navEmphasis: false,
    navLink: '#all-products',
    isExternalLink: false,
    wasInView: false,
    offset: Infinity,
  },
  places: {
    navTitle: 'Ultime istallazioni',
    navEmphasis: false,
    navLink: '#places',
    isExternalLink: false,
    wasInView: false,
    offset: Infinity,
  },
  certs: {
    navTitle: 'Certificazioni',
    navEmphasis: false,
    navLink: '#certs',
    isExternalLink: false,
    wasInView: false,
    offset: Infinity,
  },
  footer: {
    navTitle: 'Vai al sito',
    navEmphasis: true,
    navLink: 'http://www.elconmegarad.com',
    isExternalLink: true,
    wasInView: false,
    offset: Infinity,
  },
};

const reducerMap = {
  [SECTION_OFFSET_CHANGE]: (state, action) => {
    const { id, offset } = action.payload;
    const sectionOverlap = {
      [id]: Object.assign({}, state[id], { offset })
    };

    return Object.assign({}, state, sectionOverlap);
  },
  [SECTION_SET_IN_VIEW]: (state, action) => {
    const { id } = action.payload;
    const sectionOverlap = {
      [id]: Object.assign({}, state[id], { wasInView: true })
    };

    return Object.assign({}, state, sectionOverlap);
  },
};

export default handleActions(reducerMap, defaultState);



/** WEBPACK FOOTER **
 ** ./web/js/reducers/sections.js
 **/